import "./sidebar.css";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LeadSideBar = () => {
  const userType = localStorage.getItem("type") || "";
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/internal/lead/login";
  };

  const handleSideBarClick = (route) => {
    navigate(`/home/${route}`);
  };

  /* ---------- ACTIVE KEY FROM URL ---------- */
  const getActiveKey = () => {
    const path = location.pathname;

    if (path.includes("/followups")) return "followups";
    if (path.includes("/users")) return "users";
    if (path.includes("/exam")) return "exam";
    if (path.includes("/lead-settings")) return "lead-settings";
    if (path.includes("/user-settings")) return "user-settings";

    return "lead-list"; // default
  };

  const activeKey = getActiveKey();

  return (
    <nav id="sidebarMenu" className="collapse d-lg-block sidebar bg-white">
      <div className="d-flex flex-column h-100 position-sticky">
        <div>
          <div className="text-center py-3">
            <img src="/images/Original.png" alt="Achieversiq" width={200} />
          </div>

          <hr />

          <div className="list-group list-group-flush mx-3 mt-4">
            <a
              onClick={() => handleSideBarClick("lead-list")}
              className={`list-group-item list-group-item-action py-2 ripple ${
                activeKey === "lead-list" ? "active primary-button" : ""
              }`}
            >
              <i className="fas fa-tachometer-alt fa-fw me-3"></i>
              <span>Home</span>
            </a>
            {(userType === "admin" || userType === "Admin") && (
              <>
                <a
                  onClick={() => handleSideBarClick("users")}
                  className={`list-group-item list-group-item-action py-2 ripple ${
                    activeKey === "users" ? "active primary-button" : ""
                  }`}
                >
                  <i className="fas fa-lock fa-fw me-3"></i>
                  <span>Users</span>
                </a>

                <a
                  onClick={() => handleSideBarClick("exam")}
                  className={`list-group-item list-group-item-action py-2 ripple ${
                    activeKey === "exam" ? "active primary-button" : ""
                  }`}
                >
                  <i className="fas fa-lock fa-fw me-3"></i>
                  <span>Examination</span>
                </a>

                <a
                  onClick={() => handleSideBarClick("lead-settings")}
                  className={`list-group-item list-group-item-action py-2 ripple ${
                    activeKey === "lead-settings" ? "active primary-button" : ""
                  }`}
                >
                  <i className="fas fa-money-bill fa-fw me-3"></i>
                  <span>Lead Settings</span>
                </a>
              </>
            )}
            {/* <a onClick={() => handleSideBarClick("courses")} className={list-group-item list-group-item-action py-2 ripple ${activeKey === 'courses' ? 'active primary-button' : ''}}> <i className="fas fa-chart-bar fa-fw me-3"></i><span>Courses</span> </a> */}{" "}
            {/* {userType === 'admin' || userType === 'Admin' && ( <> <a onClick={() => handleSideBarClick("users")} className={list-group-item list-group-item-action py-2 ripple ${activeKey === 'users' ? 'active primary-button' : ''}}> <i className="fas fa-lock fa-fw me-3"></i><span>Reports</span> </a> </> )} */}
            {["admin", "agent"].includes(userType.toLowerCase()) && (
              <a
                onClick={() =>
                  handleSideBarClick(`followups?for=${userType.toLowerCase()}`)
                }
                className={`list-group-item list-group-item-action py-2 ripple ${
                  activeKey === "followups" ? "active primary-button" : ""
                }`}
              >
                <i className="fas fa-money-bill fa-fw me-3"></i>
                <span>Follow Ups</span>
              </a>
            )}
            <a
              onClick={() => handleSideBarClick("user-settings")}
              className={`list-group-item list-group-item-action py-2 ripple ${
                activeKey === "user-settings" ? "active primary-button" : ""
              }`}
            >
              <i className="fas fa-money-bill fa-fw me-3"></i>
              <span>User Settings</span>
            </a>
          </div>
        </div>

        <div className="mt-auto mx-3 mb-4">
          <button className="btn btn-danger w-100" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt me-2"></i>Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default LeadSideBar;
